import styled, { css } from "styled-components";
import { breakpoints } from "../../../../../shared-logic/themes/lexusTheme";
import type { SidebarVariantsType } from "./Sidebar";

// STYLES
const basket = css`
    display: none;
    flex-direction: column;
    background-color: var(--color-white);
    border-inline-start: 1px solid var(--color-platinum-light);

    @media screen and (min-width: ${breakpoints.xl}) {
        display: flex;
        position: relative;
        align-self: stretch;
        width: 100%;
        min-width: 379px;
        padding-block: 0;
        padding-inline: var(--spacing-5);
        padding-block-end: var(--spacing-4);

        &::after {
            display: block;
            position: absolute;
            top: 0;
            left: 100%;
            width: 100vw;
            height: 100%;
            content: "";
            background-color: var(--color-white);
        }
    }

    @media screen and (min-width: ${breakpoints.max}) {
        padding-inline-end: 0;
    }

    @supports not (border-inline: black) {
        border-left: 1px solid var(--color-platinum-light);
    }

    @supports not (padding-inline: 0) {
        padding-bottom: var(--spacing-4);
        padding-left: var(--spacing-5);
        padding-right: 0;
    }
`;

const basketDetails = css`
    display: flex;
    position: sticky;
    bottom: 0;
    flex-direction: column;
    width: 100%;
    height: auto;
    margin-top: auto;

    @media screen and (min-width: ${breakpoints.xl}) {
        top: 56px;
        min-width: 379px;
        margin-top: 0;
        padding: 0 var(--spacing-5);
    }

    @media screen and (min-width: ${breakpoints.max}) {
        padding-inline-end: 0;
    }
`;

// COMPONENT
export const SidebarVariants = {
    basket,
    "basket-details": basketDetails,
};

const SidebarVariant = styled.div<{ variant: SidebarVariantsType }>`
    ${(props) =>
        props.variant &&
        css`
            ${SidebarVariants[props.variant]}
        `};
`;

export default SidebarVariant;
